import {useContext} from 'react'
import DynamicTable from '../../../../components/DynamicTable/DynamicTable'
import {SupplierMappingDetails} from '../../context'
import SupplierMappingTableRow from './SupplierMappingTableRow'
import {SUPPLIER_MAPPING_TABLE_COLUMNS} from '../../utils'

const SupplierMappingTable = () => {
  const {supplierUsersList, isLoading, hasWritePermission, checkedRows, setCheckedRows,onSortingChange,filters} =
    useContext(SupplierMappingDetails)

  return (
    <DynamicTable
      id='kt_table_supplier_users'
      data={supplierUsersList}
      sortableColumns={SUPPLIER_MAPPING_TABLE_COLUMNS}
      TableRow={SupplierMappingTableRow}
      loading={isLoading}
      checkedRows={checkedRows}
      hasPermission={hasWritePermission}
      checkedRowId={'productId'}
      filters={filters}
      setCheckedRows={setCheckedRows}
      onSortingChange={onSortingChange}
      tableClass='table-row-dashed table-row-gray-300 align-top gs-0 gy-2 mb-15'
      tableHeaderClass='table-row-bordered'
    />
  )
}

export default SupplierMappingTable
